import type { ConferenceVotingRound, ConferenceVotingRoundReport, Locale } from "@/types";

export function calculateState(votingRound: ConferenceVotingRound, votingRoundReport: ConferenceVotingRoundReport = null) {
  if (votingRoundReport && votingRoundReport.status === "finished") return "finished"
  if (votingRound.status !== "scheduled" && votingRound.closedAt === null && votingRound.openedAt === null) return "available"

  return votingRound.status;
}

export function label(votingRound: ConferenceVotingRound, locale: Locale) {
  if (!votingRound) return ""
  return votingRound.title?.[locale] || votingRound.name || votingRound.reference;
}
